import React, { useState } from "react";

import "./Calculator.css";
import { Typography } from "@mui/material";
import LoanDetails from "./LoanDetails/LoanDetails";

const Calculator = () => {
  // State variables for results
  const [newEmi, setNewEmi] = useState(null);
  const [monthlySavings, setMonthlySavings] = useState(null);
  const [totalInterestSaved, setTotalInterestSaved] = useState(null);
  const [processingFeeAmount, setProcessingFeeAmount] = useState(null);
  const [netSavings, setNetSavings] = useState(null);

  const handleCalculatorData = (data) => {
    setNewEmi(data.EMI);
    setMonthlySavings(data.monthlySavings);
    setTotalInterestSaved(data.totalInterestSaved);
    setProcessingFeeAmount(data.processingFeeAmount);
    setNetSavings(data.netSavings);
  };

  return (
    <>
      <div
        id="calculator--box"
        className="calculator_box d-flex flex-column flex-md-row align-items-md-start gap-4 w-100"
      >
        <aside id="loan_details">
          <LoanDetails onData={handleCalculatorData} />
        </aside>
        <section id="loan_estimate" className="">
          <div className="loan_estimate__container rounded pb-5">
            <div className="p-3">
              <Typography
                sx={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontFamily: "'Archivo', sans-serif",
                }}
                className="archivo fw-bold"
              >
                Your loan estimate
              </Typography>
              <div className="calculator_box w-100  gap-3 mt-3">
                <div
                  id="monthly-payment"
                  className="d-flex flex-column text-wrap align-items-start justify-content-start"
                >
                  <Typography
                    sx={{
                      fontSize: "19.9267px",
                      // color: "#623174",
                      color: "#59266D",
                      letterSpacing: "normal",
                      fontFamily: "'Archivo', sans-serif",
                      textAlign: "start",
                    }}
                    className="mt-1"
                  >
                    New EMI Amount
                  </Typography>
                  <p className="monthly_payment text-start m-0 text-break archivo">
                    {/* {totalingData[0].monthlyPayment} */}
                    {newEmi}
                  </p>
                </div>
                <div className="totaling">
                  <div className="">
                    <div className="total__labels d-flex justify-content-between align-items-start">
                      <p className="totals text-break archivo m-0">
                        Monthly saving on EMI
                      </p>
                      <p className="amount text-break archivo m-0">
                        {monthlySavings}
                      </p>
                    </div>
                    <div className="total__labels d-flex justify-content-between align-items-start">
                      <p className="totals text-break archivo m-0">
                        Total interest saved
                      </p>
                      <p className="amount text-break archivo m-0">
                        {/* {totalingData[0].interestPayment} */}
                        {totalInterestSaved}
                      </p>
                    </div>
                    <div className="total__labels d-flex justify-content-between align-items-start">
                      <div className="totals d-flex align-items-center gap-1  m-0">
                        <p className="totals text-break archivo m-0 ">
                          Processing Fee
                        </p>
                      </div>
                      <p className="amount text-break archivo m-0">
                        {processingFeeAmount}
                      </p>
                    </div>

                    <div className="total__labels d-flex justify-content-between align-items-start">
                      <p className="totals text-break archivo m-0">
                        Net saving
                      </p>
                      <p className="amount text-break archivo m-0">
                        {netSavings}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Calculator;
